<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title show-sm>Formulier</ion-title>
        <ion-buttons slot="end">
            <ion-button expand="block" color="primary" fill="outline" (click)="router.navigate(['orders'])">
                <ion-icon name="arrow-back" size="large"></ion-icon>Order {{ordnr}}
            </ion-button>
            <ion-button id="vrijgave" expand="block" color="primary" fill="solid" *ngIf="formBase && !formBase.writingJobs">
                <ion-icon name="save" size="large"></ion-icon> Vrijgave
            </ion-button>
            <ion-alert trigger="vrijgave" header="Na vrijgave kan dit formulier niet meer gewijzigd worden. Doorgaan?"
            [buttons]="confirmButtons" (didDismiss)="doVrijgave($event)"></ion-alert>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content *ngIf="initDone">
    <app-formbase [formnr]="formHdr" [ordnr]="ordnr"></app-formbase>
</ion-content>

<div *ngIf="formBase">
    <app-imageview  [open]="viewerOpen" [idx]="idx" [imgs]="formBase.idx"
        [ordnr]="ordnr" [baseSub]="'/form-'+formHdr" [currSub]=""
        (close)="viewerOpen = false; formBase.loadImgs()">
    </app-imageview>
</div>
